import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import Overlay from '~/components/overlays/Overlay.vue';
import MaterialGallery from '~/components/overlays/MaterialGallery.vue';
export default {
  props: ['material', 'newCase'],
  components: {
    Overlay: Overlay,
    MaterialGallery: MaterialGallery
  },
  data: function data() {
    return {
      pCount: null,
      timer: null,
      pItem: null,
      images: [],
      figures: [],
      currentImageIndex: 0,
      currentImage: []
    };
  },
  computed: {
    isLast: function isLast() {
      return this.currentImageIndex >= this.images.length - 1;
    },
    isFirst: function isFirst() {
      return this.currentImageIndex <= 0;
    },
    appStore: function appStore() {
      return useAppStore();
    }
  },
  mounted: function mounted() {
    var _this = this;
    // Fix editor bug
    var editables = document.querySelectorAll('[contenteditable="true"]');
    editables.forEach(function (el) {
      el.setAttribute('contenteditable', false);
    });

    // Add '»' to blockquote text end
    var quotes = this.$el.querySelectorAll('blockquote');
    quotes.forEach(function (el) {
      el.firstChild.nodeValue = el.firstChild.nodeValue + '»';
    });
    this.lazyImages();
    this.iframely();
    this.figures = document.querySelectorAll('.medium-insert-images figure');
    var images = document.querySelectorAll('.medium-insert-images img');
    this.images = _toConsumableArray(images).map(function (el) {
      var filePath = el.src.split('/');
      return {
        name: filePath[filePath.length - 1]
      };
    });
    this.figures.forEach(function (el, i) {
      el.classList.add("gallery-image");
      el.imageIndex = i;
      el.addEventListener('click', _this.openGallery.bind(event, i));
    });
  },
  methods: {
    // throttled scroll/resize
    scroller: function scroller() {
      var _this2 = this;
      this.timer = this.timer || setTimeout(function () {
        _this2.timer = null;
        _this2.inView();
      }, 300);
    },
    // image in view?
    inView: function inView() {
      var _this3 = this;
      if (!this.pItem.length) return;
      requestAnimationFrame(function () {
        var wT = window.scrollY,
          wB = wT + window.innerHeight,
          cRect,
          pT,
          pB,
          p = 0;
        while (p < _this3.pItem.length) {
          cRect = _this3.pItem[p].getBoundingClientRect();
          pT = wT + cRect.top;
          pB = pT + cRect.height;
          if (wT < pB && wB > pT) {
            _this3.loadFullImage(_this3.pItem[p]);
            _this3.pItem[p].classList.remove('replace');
          } else p++;
        }
        _this3.pCount = _this3.pItem.length;
      });
    },
    // replace with full image
    loadFullImage: function loadFullImage(item) {
      var href = item && (item.getAttribute('data-href') || item.href);
      var pImg = item.querySelector && item.querySelector('img.preview');
      if (!href) return;

      // load image
      var img = new Image();
      if (item.dataset) {
        img.srcset = item.dataset.srcset || '';
        img.sizes = item.dataset.sizes || '';
        img.style.maxWidth = pImg.style.maxWidth || 'auto';
      }
      img.src = href;
      img.className = 'reveal';
      img.className = 'reveal';
      if (img.complete) addImg();else img.onload = addImg;

      // replace image
      function addImg() {
        pImg.className += " transform";
        requestAnimationFrame(function () {
          // disable click
          if (href === item.href) {
            item.style.cursor = 'default';
            item.addEventListener('click', function (e) {
              e.preventDefault();
            }, false);
          }

          // add full image
          item.prepend(img);
          img.addEventListener('animationend', function (e) {
            // remove preview image
            if (pImg) {
              e.target.alt = pImg.alt || '';
              item.removeChild(pImg);
              e.target.classList.remove('reveal');
            }
          });
        });
      }
    },
    lazyImages: function lazyImages() {
      var _this4 = this;
      // start
      this.pItem = document.getElementsByClassName('progressive replace');

      // scroll and resize events
      window.addEventListener('scroll', this.scroller, false);
      window.addEventListener('resize', this.scroller, false);

      // DOM mutation observer
      if (MutationObserver) {
        var observer = new MutationObserver(function () {
          if (_this4.pItem.length !== _this4.pCount) _this4.inView();
        });
        observer.observe(document.body, {
          subtree: true,
          childList: true,
          attributes: true,
          characterData: true
        });
      }

      // initial check
      this.inView();
    },
    iframely: function iframely() {
      if (!this.appStore.iframelyLoaded) return this.loadIframely();
      window.iframely.load();
    },
    loadIframely: function loadIframely() {
      var _this5 = this;
      if (!this.appStore.iframelyLoaded) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "//cdn.iframe.ly/embed.js?api_key=331ec6b352c63987229fa4";
        document.head.append(script);
        script.onload = function () {
          _this5.appStore.setState({
            key: 'iframelyLoaded',
            value: true
          });
          _this5.iframely();
        };
      } else {
        this.iframely();
      }
    },
    openGallery: function openGallery(index, event) {
      this.currentImageIndex = index;
      this.$modalityStore.openModal({
        type: 'overlay',
        name: 'gallery'
      });
      event.target.blur();
      document.getElementById('main-app').click();
    },
    next: function next() {
      if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
      if (this.currentImageIndex >= this.images.length - 1) {
        return this.currentImageIndex = this.images.length - 1;
      }
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentImageIndex++;
    },
    prev: function prev() {
      if (typeof this.currentImageIndex == 'undefined') return this.currentImageIndex = 0;
      if (this.currentImageIndex <= 0) return this.currentImageIndex = 0;
      document.getElementById('cases-overlay').scrollTop = 0;
      this.currentImageIndex--;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this6 = this;
    this.figures.forEach(function (el) {
      el.removeEventListener('click', _this6.openGallery);
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.scroller);
    window.removeEventListener('resize', this.scroller);
  }
};